var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel3DIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20683 4.97604L0.492406 2.42976L7.26359 0L13.9569 2.47638L7.20683 4.97604ZM7.64433 10.8883C9.07916 10.4285 10.5312 10.4855 11.8733 10.952L14.4686 5.87583V3.2331L7.64433 5.7603V10.8883ZM19.4177 0.0782544L19.4298 20.4945L28 16.8266L19.4177 0.0782544ZM12.6829 11.3032C14.4133 12.2734 15.709 13.6889 15.9048 15.8165C15.7694 17.433 15.1101 18.9204 14.0135 20.0565C12.8398 21.2725 11.2549 21.97 9.6653 21.97C8.06422 21.97 6.4709 21.3784 5.2938 20.3469C4.08275 19.2856 3.41146 17.863 3.39976 16.3374C3.4539 14.1662 4.41842 12.3984 6.76566 11.2431V5.75765L0 3.19201V12.2622L3.67259 13.9583C2.96166 15.0754 2.54898 16.4051 2.54898 17.8323C2.54898 21.7909 5.72234 25 9.63687 25C12.9495 25 15.731 22.7019 16.5082 19.5963L18.434 20.4946L18.4218 0.078365L12.6829 11.3032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel3DIconWhite);
export default __webpack_public_path__ + "static/media/model-3d-icon-white.26ed9783d52490b4ab4692215c7e53c5.svg";
export { ForwardRef as ReactComponent };